import { render, staticRenderFns } from "./StudentHomeworkPreview.vue?vue&type=template&id=5973f8b2&"
import script from "./StudentHomeworkPreview.vue?vue&type=script&lang=js&"
export * from "./StudentHomeworkPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports